/* 虚拟滚动列表 */
import { forwardRef, useState, useMemo } from "react";
import useResizeObserver from "@utils/useResizeObserver";
import { flushSync } from "react-dom";

const VirtualScrolling = forwardRef((props, ref) => {
    const {
        dataSource,
        children,
        col=1, // 列数
        gap=0, // 间距
        rowGap=0, // 垂直方向的间距
        columnGap=0, // 水平方向的间距
        aspectRatio=1, // 等比
    } = props

    if (!col) throw new Error('非法参数col')

    const [containerHeight, setContainerHeight] = useState(0)
    const [containerWidth, setContainerWidth] = useState(0)
    const targetRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            // 处理尺寸变化的逻辑
            setContainerWidth(entry.contentRect.width)
            setContainerHeight(entry.contentRect.height)
        }
    })
    // 数据总数
    const totalCount = useMemo(() => {
        return dataSource?.length??0
    }, [dataSource])
    // 子项宽度
    const itemWidth = useMemo(() => {
        return Math.floor((containerWidth - (col - 1) * columnGap) / col)
    }, [col, columnGap, containerWidth])
    // 子项高度
    const itemHeight = useMemo(() => {
        if (!aspectRatio) return itemWidth
        return itemWidth / aspectRatio
    }, [itemWidth, aspectRatio])
    // 横向滚动
    const [scrollLeft, setScrollLeft] = useState(0)
    // 纵向滚动
    const [scrollTop, setScrollTop] = useState(0)
    // 容器滚动事件
    const handleScroll = (e) => {
        flushSync(() => {
            // setScrollLeft(e.target.scrollLeft)
            setScrollTop(e.target.scrollTop)
        })
    }

    // 所有 items 的位置
    const offsets = useMemo(() => {
        const list = []
        for (let i = 0; i < totalCount; i++) {
            list[i] = {
                left: (i % col) * (itemWidth + columnGap),
                top: Math.floor(i / col) * (itemHeight + rowGap)
            }
        }
        return list
    }, [totalCount, col, rowGap, columnGap, itemWidth, itemHeight])

    // 找 startIdx 和 endIdx
    let startIdx = offsets.findIndex(pos => pos.top > scrollTop)
    let endIdx = offsets.findIndex(pos => pos.top > scrollTop + containerHeight)
    if (endIdx == -1 && containerHeight > 0) endIdx = totalCount - 1

    // 上下扩展补充2个 item
    const paddingCount = 2 * col;
    startIdx = Math.max(startIdx - paddingCount, 0); // 处理越界情况
    endIdx = Math.min(endIdx + paddingCount, totalCount - 1);

    // 计算高度
    const contentHeight = Math.floor(totalCount / col) * (itemHeight + rowGap)

    // 需要渲染的items
    const renderItems = []
    for (let i = startIdx; i <= endIdx; i++) {
        const pos = offsets[i]
        if (!pos) continue
        const component = children({
            key: i,
            index: i,
            style: {
                position: 'absolute',
                left: pos.left,
                top: pos.top
            },
            data: dataSource[i]
        })
        renderItems.push(component)
    }

    return (
        <div
            ref={targetRef}
            className={"_beauty_scrollbar"}
            style={{
                width: '100%',
                height: '100%',
                overflow: 'auto',
                position: 'relative',
            }}
            onScroll={handleScroll}
        >
            <div style={{ width: "100%", height: contentHeight }}>
            {
                renderItems
            }
            </div>
        </div>
    )
})

export default VirtualScrolling